<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="primary"
      icon="mdi-account-group"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Documents") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'document.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <advanced-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.thumb="{ item }">
          <v-btn icon>
            <a :href="item.url | addToken" target="_blank">
              <v-img
                v-if="
                  item.mime_type &&
                    (item.mime_type.startsWith('image/png') ||
                      item.mime_type.startsWith('image/jpeg'))
                "
                :src="item.thumb"
                height="50"
                width="100"
                contain
                flat
              ></v-img>
              <v-icon v-else>mdi-file</v-icon>
            </a>
          </v-btn>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></advanced-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";
import { persistentTableOptions } from "../../../plugins/mixins";
import axios from "axios";

var cancel;
var CancelToken = axios.CancelToken;

export default {
  name: "app-document-list",
  mixins: [persistentTableOptions],
  data() {
    return {
      headers: [
        {
          text: "",
          align: "left",
          value: "thumb"
        },
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Ablaufdatum",
          align: "left",
          value: "expire"
        },
        { text: "", value: "action", sortable: false }
      ],
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: [],

      filters: []
    };
  },

  mounted() {
    this.getData();
  },
  computed: {
    filterCols() {
      return [
        {
          name: this.$t("type"),
          type: "select",
          items: []
        }
      ];
    }
  },
  methods: {
    async getData() {
      this.loading = true;
      if (cancel != undefined) {
        cancel();
      }
      let response = await fetchItems(
        {
          ...this.options,
          search: this.search,
          type_filter: this.filters
        },
        new CancelToken(function executor(c) {
          cancel = c;
        })
      );
      this.items = response.data;
      this.total = response.meta.total;
      this.filterCols[0].items = response.document_types;
      this.loading = false;
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Document?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "document.edit", params: { id: url } });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
